import { render, staticRenderFns } from "./Demo.vue?vue&type=template&id=892c5e34&scoped=true"
import script from "./Demo.vue?vue&type=script&lang=ts"
export * from "./Demo.vue?vue&type=script&lang=ts"
import style0 from "./Demo.vue?vue&type=style&index=0&id=892c5e34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892c5e34",
  null
  
)

export default component.exports